import { render, staticRenderFns } from "./ProfilePasswordChange.vue?vue&type=template&id=52fd8d5d&scoped=true"
import script from "./ProfilePasswordChange.vue?vue&type=script&lang=js"
export * from "./ProfilePasswordChange.vue?vue&type=script&lang=js"
import style0 from "./ProfilePasswordChange.vue?vue&type=style&index=0&id=52fd8d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd8d5d",
  null
  
)

export default component.exports